import React from "react";
import { Itinerary, TripDay } from "../types";
import IconComponent from "./IconComponent";
import { FaPlaneArrival, FaPlaneDeparture } from "react-icons/fa6";
import MapItinerary from "./MapItinerary";
import { Link } from "react-router-dom";
import { routes } from "../routes/routes";

interface ChatItineraryProps {
  itinerary: Itinerary;
  onImageError: Function;
  selectedDay: TripDay | undefined;
  setShowModal: Function;
  trip_days: React.JSX.Element;
}

const ChatItinerary: React.FC<ChatItineraryProps> = ({
  itinerary,
  onImageError,
  selectedDay,
  setShowModal,
  trip_days,
}) => {
  return (
    <div className="card border-0">
      {itinerary.data &&
        itinerary.data.images &&
        itinerary.data.images.length > 0 && (
          <img
            src={itinerary.data.images[0].url}
            className="card-img-top itinerary-cover"
            onError={() => {
              onImageError(itinerary);
            }}
          />
        )}

      <div className="card-body itinerary-title bg-white text-center rounded-4">
        <h5>
          {itinerary.data && itinerary.data.title
            ? itinerary.data.title
            : "Itinéraire généré"}
        </h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col">
            <h4>
              <IconComponent icon={FaPlaneArrival} className="me-2" />
              {itinerary.data ? itinerary.data.arrive_city : ""}
            </h4>
            <div className="text-muted">Arrival City</div>
          </div>
          <div className="col text-end">
            <h4>
              <IconComponent icon={FaPlaneDeparture} className="me-2" />
              {itinerary.data ? itinerary.data.return_city : ""}
            </h4>
            <div className="text-muted">Return City</div>
          </div>
        </div>
      </div>

      <div className="card-body py-0 h-100">
        {itinerary && itinerary.data && (
          <div className="w-100 shadow">
            <MapItinerary
              tripDays={itinerary.data.trip_days}
              selectedDay={selectedDay}
            />
          </div>
        )}
      </div>

      {trip_days}


    <div className="card-body">
          <div className="d-flex justify-content-between">
            <div className="btn btn-outline-danger">
              Modifier cet itinéraire
            </div>

            {itinerary && !itinerary.data.hotel_cities && (
              <div
                className="btn btn-primary"
                onClick={() => setShowModal(true)}
              >
                Valider cet itinéraire
              </div>
            )}
            {itinerary && itinerary.data.hotel_cities && (
              <Link
                className="btn btn-primary"
                to={`${routes.itinerary.path}/${itinerary.uuid}`}
              >
                Explorer
              </Link>
            )}
          </div>
        </div>
    </div>
  );
};

export default ChatItinerary;
